import React, { Component } from 'react';
import { localize } from 'react-localize-redux';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';

import { toFriendlyDateString } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

import { FaTags as PromotionsIcon } from 'react-icons/fa';

export default withMobileDialog()(
  localize()(
    class TenantPromotionDialog extends Component {
      render() {
        const { fullScreen } = this.props;

        const promotion = this.props.promotion;

        const style = {
          table_header: {
            margin: '5px -20px 10px -20px',
            backgroundColor: '#f1f1f1',
            padding: '5px 10px',
            fontSize: '14px',
            fontWeight: '800',
          },
        };

        return (
          <Dialog
            fullScreen={fullScreen}
            open={this.props.showPromotion}
            onClose={this.props.togglePromotionDialog}
            aria-labelledby="promotion-dialog"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle>
              <h3 style={{ textAlign: 'center', margin: 0 }}>{promotion.name}</h3>
            </DialogTitle>
            <DialogContent>
              <div>
                <div style={{ textAlign: 'center' }}>
                  {promotion.image && (
                    <img src={promotion.image} alt={promotion.name} style={{ maxWidth: '500px' }} />
                  )}

                  {!promotion.image && <PromotionsIcon size={250} color={colors.LIGHT_GRAY} />}
                </div>
                <div className="row" style={style.table_header}>
                  <div style={{ textAlign: 'center' }}>
                    <span style={{ textAlign: 'center' }}>
                      {this.props.translate('promotions.details')}
                    </span>
                  </div>
                </div>
                <div className="row" style={{ fontSize: '15px', marginTop: '15px' }}>
                  <p style={{ marginBottom: '0', whiteSpace: 'pre-line', wordWrap: 'break-word' }}>
                    {promotion.description}
                  </p>
                </div>
              </div>
              <div>
                {promotion.expiration_date && (
                  <div className="row" style={{ fontSize: '15px', marginTop: '15px' }}>
                    <span style={{ fontFamily: 'Circular-Bold' }}>
                      {this.props.translate('expiryDate')}:
                    </span>{' '}
                    {toFriendlyDateString(promotion.expiration_date)}
                  </div>
                )}
                {promotion.vendor && (
                  <div className="row" style={{ fontSize: '15px', marginTop: '15px' }}>
                    <span style={{ fontFamily: 'Circular-Bold' }}>
                      {this.props.translate('promotions.providedBy')}:
                    </span>{' '}
                    {promotion.vendor}
                  </div>
                )}
                {promotion.link && (
                  <div style={{ fontSize: '15px', marginTop: '15px' }}>
                    <a href={promotion.link} target={'_blank'} rel="noopener noreferrer">
                      {' '}
                      {this.props.translate('clickForMoreDetails')}{' '}
                    </a>
                  </div>
                )}
              </div>
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                label={this.props.translate('close')}
                primary={true}
                onClick={this.props.togglePromotionDialog}
              />
            </DialogActions>
          </Dialog>
        );
      }
    }
  )
);
